export interface FAQItem {
  question: string;
  answer: string;
}

export const faqData: FAQItem[] = [
  {
    question: '你們出版的契約書都是最新版嗎?',
    answer: '是的, 都是符合內政部規定"應記載及不得記載事項"之最新版本, 並且隨法令修改隨時更新條款內容。'
  },
  {
    question: '可以請你們客製化我公司專屬的契約書嗎?',
    answer: '可以, 但是每單樣契約書要訂購滿1000份印刷廠才會開版, 建議若貴公司甫成立規模不大時可先購買敝公司之公版使用, 若一開始就大量印製, 如果遇到上級法令修改還要重新印製, 尚未使用的契約書就造成浪費了。'
  },
  {
    question: '你們契約書最低訂購量幾份?',
    answer: '每單樣契約書訂購以一本(50份)為單位, 每次訂購金額滿$2000免運費($100)。'
  },
  {
    question: '付款方式有哪些？',
    answer: '到敝公司現場購買以現金付款為主, 郵寄配送有事先轉帳及貨到付款(另加$50手續費)兩種付款方式。'
  },
  {
    question: '下單訂購後何時可收到契約書?',
    answer: '下單訂購且轉帳完成通常隔天或隔一天可收到契約書, 遇例假日則順延。(貨到付款單以下單日為出貨日)'
  },
  {
    question: '現況說明書和不動產說明書有何不同?',
    answer: '不動產說明書和現​況說明書兩種都屬於不動產說明書的一部份, 差別在於現況說明書的內容是仲介在簽委, 託同時給屋主（或地主）勾選, 不動產說明書則是簽完委託後由仲介公司填寫製作的產調, 依照內政部的規定, 當物件成交時這兩種說明書都應該要附在買賣契約書當作契約之一部分, 當地政局人員不定期到公司抽查契約書時, 這兩種契約書也都是必檢項目。'
  }
];
